import { t } from "../../../services/utils";
import React from "react";
import { lightBlue900 } from "../../../constants/colors";
class LikesView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        width: "100%",
        height: "100%",
        backgroundColor: "white",
      },
      likes: {
        fontSize: 16,
        paddingLeft: 10,
        paddingTop: 8,
        color: lightBlue900,
        fontWeight: 500,
      },
    };
    let title;
    if (this.props.likes.length === 1) {
      title = "1 like";
    } else {
      title = `${this.props.likes.length} likes`;
    }
    return (
      <div style={styles.container}>
        <div style={styles.likes}>{title}</div>
      </div>
    );
  };
  static getHeight(props) {
    return 36;
  }
}
export default LikesView;
